import { Boxes, CheckCircle2 } from "lucide-react";
import { 
  Globe, 
  Code2, 
  Zap, 
  Sparkles, 
  Component, 
  SunMoon, 
  Palette as IconsPalette,
  Database,
  FormInput,
  KeyRound,
  Video,
  TrendingUp,
  Wand2,
  Route,
  PanelLeftClose,
  Command,
  ListChecks,
  TestTube2,
  Bell
} from "lucide-react";

export function AuraStackCompatibility() {
  const stackSections = [
    {
      title: "Core",
      status: "Pass",
      items: [
        { icon: Globe, text: "React 18" },
        { icon: Code2, text: "TypeScript 5" },
        { icon: Zap, text: "Vite (SWC)" }
      ]
    },
    {
      title: "UI & styling",
      status: "Pass",
      items: [
        { icon: Sparkles, text: "Utility-first classes" },
        { icon: Component, text: "Shadcn/Radix-friendly patterns" },
        { icon: SunMoon, text: "Theme-ready (light/dark)" },
        { icon: IconsPalette, text: "Lucide icons" }
      ]
    },
    {
      title: "Data & forms",
      status: "Pass",
      items: [
        { icon: Database, text: "TanStack Query usage compatible" },
        { icon: FormInput, text: "React Hook Form + Zod ready" },
        { icon: KeyRound, text: "Supabase auth/storage compliant" }
      ]
    },
    {
      title: "Media & viz",
      status: "Pass",
      items: [
        { icon: Video, text: "MediaPipe Tasks Vision supported" },
        { icon: TrendingUp, text: "Recharts components compatible" },
        { icon: Wand2, text: "Animations minimized; prefers-reduced-motion respected" }
      ]
    },
    {
      title: "Navigation & UX",
      status: "Pass",
      items: [
        { icon: Route, text: "React Router patterns accounted for" },
        { icon: PanelLeftClose, text: "Resizable panels friendly" },
        { icon: Command, text: "Command palette patterns (CMDK) fit" }
      ]
    },
    {
      title: "Quality & DX",
      status: "Pass",
      items: [
        { icon: ListChecks, text: "ESLint + PostCSS compatible" },
        { icon: TestTube2, text: "Playwright-friendly markup" },
        { icon: Bell, text: "Sonner toast patterns supported" }
      ]
    }
  ];

  return (
    <div className="mt-8 rounded-2xl border border-slate-200 bg-white shadow-sm">
      <div className="px-4 py-3 border-b border-slate-200 flex items-center justify-between">
        <div className="flex items-center gap-2">
          <div className="h-4 w-4 p-1 rounded-md bg-emerald-50 text-emerald-600 border border-emerald-100 flex items-center justify-center">
            <Boxes className="h-2.5 w-2.5" />
          </div>
          <h2 className="text-[15px] font-medium tracking-tight text-slate-900">Stack compatibility</h2>
        </div>
        <span className="hidden sm:inline-flex items-center gap-1 px-2 py-0.5 rounded-full text-xs font-medium border border-emerald-200 bg-emerald-50 text-emerald-700">
          <CheckCircle2 className="h-3.5 w-3.5" />
          Verified
        </span>
      </div>
      
      <div className="p-4 grid grid-cols-1 md:grid-cols-2 gap-3">
        {stackSections.map((section, index) => (
          <div key={index} className="rounded-xl border border-slate-200 p-3">
            <div className="flex items-center justify-between">
              <div className="text-[15px] font-medium text-slate-900">{section.title}</div>
              <span className="inline-flex items-center gap-1 px-2 py-0.5 rounded-full text-xs font-medium border border-emerald-200 bg-emerald-50 text-emerald-700">
                <CheckCircle2 className="h-3.5 w-3.5" />
                {section.status}
              </span>
            </div>
            <ul className="mt-2 text-[13px] text-slate-700 space-y-1">
              {section.items.map((item, itemIndex) => (
                <li key={itemIndex} className="flex items-center gap-2">
                  <item.icon className="h-3.5 w-3.5" />
                  {item.text}
                </li>
              ))}
            </ul>
          </div>
        ))}
      </div>
      
      <div className="px-4 pb-4">
        <p className="text-[13px] text-slate-600">
          All listed libraries integrate cleanly with the current patterns. No changes required for compatibility.
        </p>
      </div>
    </div>
  );
}